import { Component, OnInit, Input, Inject, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CategoryService } from 'src/app/_services/category.service';
import { first } from 'rxjs/operators';
import { DocumentService } from 'src/app/_services/document.services';
import { CategoriesComponent } from 'src/app/categories';
import { Category } from 'src/app/_models';
import { Document } from 'src/app/_models/document';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';
import { FormArray, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { PopUpComponent } from 'src/app/common/pop-up/pop-up.component';
import { MatSelectChange } from '@angular/material/select';
import { COMMENT_APPENDER, COMMENT_APPLICABLE_METADATA_KEYS, MAX_CHARS, PORTAL_USER_INFO_KEY } from 'src/app/constants/portal-user-info';
import { MARK_FOR_DELETE_KEY, REASON_FOR_DELETE_KEY, REASON_FOR_DELETE_PROMPT } from 'src/app/constants/mark-for-delete';

@Component({
  selector: 'app-dialog-update-category',
  templateUrl: './dialog-update-category.component.html',
  styleUrls: ['./dialog-update-category.component.scss'],
  providers: [DatePipe]
})
export class DialogUpdateCategoryComponent implements OnInit {


  
  @ViewChild('editor') editor: JsonEditorComponent;
  @ViewChild('editorMult') editorMult: JsonEditorComponent;

  showData;

  options = new JsonEditorOptions();

  options2 = new JsonEditorOptions();
  @Input() documentID: string;
  @Output() isUpdateCategory = new EventEmitter<boolean>();
  @Output() hideDocView = new EventEmitter<boolean>();
  @Output() catID = new EventEmitter<any>();
  @Output() catName = new EventEmitter<any>();
  @ViewChild('initiateForm') initiateForm: NgForm;

  uploadMessage: boolean = false
  propertyCols: String[];
  documentProp: String[];
  selectedHeader: number;
  propertiesValue: any;
  properties: any;
  categories: Category[] = [];
  fetchedCategoryName: string;
  documentDetails: Document;
  categoryDetails: any;
  categoryNames = [];
  categoryID: any;
  categoryName: string;
  isMetaData: boolean = false
  isUpdatedCategory: boolean = false
  category: Category
  valuesForm: FormGroup
  searchCtrl: string = ""
  propertyKeys: String[] = [];
  values: any[];
  hideFields = ["SF Application ID", "Digitization User Info", "Portal User Info", "Reference Entities", "Source", "Legacy Folder ID", "Batch ID", "ImageTrust Document ID", "Deletion Requested By", "Deletion Requested Date"];
  categoryList = [3,78,17,38,44,66,70,64,30,55];
  isError = false;
  errorMessage = '';
  isAdmin = false;
  adminShowFields = ["Legacy Folder ID"];
  comment: string = "";
  portalUserInfo: any = {};
  deleteComment: string = "";

  constructor(
    //@Inject(MAT_DIALOG_DATA) public data: any,
    private documentSvc: DocumentService,
    private categoryService: CategoryService,
    private datePipe: DatePipe,
    private dialog: MatDialog
  ) { 
    this.options2.language = 'en';
    this.options.mode = 'code';
    this.options2.mode = 'tree';
    this.options2.modes = this.options.modes = ['form', 'tree', 'view'];
    //this.options2.schema = this.options.schema = schema;
    this.options2.statusBar = this.options.statusBar = false;
    this.isAdmin = JSON.parse(localStorage.getItem("isAdmin"));

    this.options2.onSelectionChange = ()=> {
      console.log(`onSelectionChange`)
    }
  }
  showJson(d) {
    return JSON.stringify(d, null, 2);
  }

  changeLog(event = null) {
    this.showData = this.editor.get();
    console.log("THIS.SHOWDATA", this.showData)
   }

  updateList(values, property, event: any) {
    const currentDate = event.target.value;
    if (property.name == "Key Date") {
      if (currentDate) {
        const d = new Date(currentDate);
        const editField = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
        let dateString = this.datePipe.transform(editField, 'yyyy-MM-dd');
        let dateStrFormat = dateString.split("-");
        values.forEach(obj => {
          if (obj.name == "Key Year") {
            obj.value = dateStrFormat[0];
          }
          if (obj.name == "Key Date") {
            obj.value = dateString;            
          }
        });      
        property['isError'] = false;
        this.initiateForm.controls[property.name].setErrors(null);
      } else {
        property['isError'] = true;
        this.initiateForm.controls[property.name].setErrors({'isError': true});
      }
    }
    if (property.data_type == "date") {
      if (currentDate) {
        const d = new Date(currentDate);
        const editField = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
        let dateString = this.datePipe.transform(editField, 'yyyy-MM-dd');        
        values.forEach(obj => {
          if (obj.name == property.name) {
            obj.value = dateString;
          }         
        });
        property['isError'] = false;
        this.initiateForm.controls[property.name].setErrors(null);
      } else {
        property['isError'] = true;
        this.initiateForm.controls[property.name].setErrors({'isError': true});
      }
    }    
  }

  ngOnInit() {
    this.uploadMessage = false
    this.categoryService.getAll().pipe(first()).subscribe(categories => {
      categories['results'].forEach(category => {
        if (!this.categoryList.includes(category.id)) {
          this.categories.push(category);
        }
      });
    });

    this.documentSvc.getDocumentDetails(this.documentID)
      .subscribe(details => {
        this.documentDetails = details;
        this.categoryID = details.categoryId;
        this.documentProp = this.documentDetails.metadata.properties;
        this.propertyCols = Object.keys(this.documentDetails.metadata.properties);
        this.categoryService.get(this.categoryID).subscribe(category => {
          this.categoryDetails = category;
          this.categoryName = this.categoryDetails.name;
        });
      });
  }
  initValues() {
    return new FormGroup({
      value: new FormControl('', Validators.required)
    })
  }
  createValuesForm(arrayProperties) {
    var formControlObject = {}
    arrayProperties.forEach(property => {
      formControlObject[property] = new FormArray([this.initValues()])
    });
    this.valuesForm = new FormGroup(
      formControlObject
    )
    this.setVaulesHandler(arrayProperties)
  }

  setVaulesHandler(arrayProperties) {
    var formData = {}
    arrayProperties.forEach(element => {
      this.deleteForm(0, element)
      if (this.documentDetails.metadata.properties[element]) {
        var values = []
        this.documentDetails.metadata.properties[element].forEach(arrayValue => {
          this.addNewValue(element)
          values.push({ value: arrayValue })
        });
        formData[element] = values
      } 
    });
    this.valuesForm.patchValue(formData)
  }

  addNewValue(property) {
    const control = <FormArray>this.valuesForm.get(property);
    control.push(this.initValues());
  }

  getValues(form, property) {
    return form.controls[property].controls;
  }

  deleteForm(index: number, property) {
    this.valuesArray(property).removeAt(index);
  }

  valuesArray(property) {
    return <FormArray>this.valuesForm.get(property)
  }

  validData() {
    return new Promise((resolve, reject) => {
      var isValidData = true;
      if (this.properties["Placeholder UUID"] && this.properties["Placeholder UUID"] != "" && !this.properties["Placeholder UUID"].includes("PLCHD")) {
        isValidData = false;
      }
      resolve(isValidData)
    });
  }

  async fetchServiceData() {
    this.isError = false;
    this.errorMessage = '';
    //console.log("UPDATED CATEGORY", this.category)
    this.category.meta_data_definition.properties.forEach(obj => {

      if (obj.data_type === "date") {        
        if (obj.value == '' || obj.value == null) {
          this.properties[obj.name] = undefined
        } else {
          const editField = new Date(obj.value);          
          let dateString = this.datePipe.transform(editField, 'MM/dd/yyyy');          
          this.properties[obj.name] = dateString;
        }        
      }
      else if (obj.data_type === "int") {
        this.properties[obj.name] = parseInt(obj.value);
      }
      else if (obj.data_type === "bool") {
        this.properties[obj.name] = false
        if (obj.value === "true") {
          this.properties[obj.name] = true
        }
      }
      else if (obj.data_type === "str") {
       if (obj.value == '' || obj.value == null || obj.value == undefined) {
          this.properties[obj.name] = ''
        }
        else {
          this.properties[obj.name] = obj.value
        }
      }

      else if (obj.data_type == "object") {
        this.properties[obj.name]= this.showData
       // console.log("WE ARE HERE", this.properties[obj.name])
      }
      else if (obj.data_type == "str array") {
        var values = []       
        if (!this.hideFields.includes(obj.name)) {
          if (this.valuesForm.value[obj.name].length == 0 || this.valuesForm.value[obj.name] == null) {
            this.properties[obj.name] = []
          }
          else {
            this.valuesForm.value[obj.name].forEach(element => {
              values.push(element.value)
            });
            this.properties[obj.name] = values
          }
        }
      }
      else {
        this.properties[obj.name] = obj.value;
      }

    })
    let isValid = await this.validData();
    if (!isValid) {
      this.isError = true;
      this.errorMessage = 'Placeholder UUID is invalid, please correct the data';
      return;
    } else {
      
      // Complete request payload for appplicable metadata comments
      this.properties[PORTAL_USER_INFO_KEY] = this.portalUserInfo;
      if (this.properties[MARK_FOR_DELETE_KEY] == true && REASON_FOR_DELETE_KEY in this.properties) {
        this.properties[REASON_FOR_DELETE_KEY] = this.deleteComment;
        console.log(this.properties[REASON_FOR_DELETE_KEY])
      }

      var updateCategoryRequest = {
        "docId": this.documentID,
        "category_id": this.categoryID,
        "properties": this.properties,
        "title": this.documentDetails.documentName

      }
      this.documentSvc.updateCategoryForDocument(updateCategoryRequest).subscribe(resp => {
        this.uploadMessage = true      
        this.categoryService.getAll().pipe(first()).subscribe(categories => {
          categories['results'].forEach(category => {
            if (!this.categoryList.includes(category.id)) {
              this.categories.push(category);
            }
          });
        });

        this.documentSvc.getDocumentDetails(this.documentID)
          .subscribe(details => {
            this.documentDetails = details;
            this.categoryID = details.categoryId;
            this.documentProp = this.documentDetails.metadata.properties;
            this.propertyCols = Object.keys(this.documentDetails.metadata.properties);
            this.categoryService.get(this.categoryID).subscribe(category => {
              this.categoryDetails = category;
              this.categoryName = this.categoryDetails.name;
            });
          }
        );
        this.portalUserInfo = {}
      })
    }
  }


  fetchMetaDataProperties(id) {
    //console.log("ID", id)
    this.categoryService.get(id).subscribe(details => {
      this.category = details;
      this.fetchedCategoryName = this.category.name
      //console.log("MetaData",details['meta_data_definition']['properties'])
      this.isMetaData = true
      var strArrayAttributes = []
      for(let element of this.category.meta_data_definition.properties)
      {
        // if(i.data_type=="str array")
        // strArrayAttributes.push(i.name)
        if (this.documentProp[element.name]) {
          element.value = this.documentProp[element.name];
        } else if (element.data_type == 'bool' && this.documentProp[element.name] != undefined) {
          if (this.documentProp[element.name]) {
            element.value = 'true';
          } else {
            element.value = 'false';
          }
        }
        this.propertyKeys.push(element.name);
        if (!this.hideFields.includes(element.name)) {
          if (element.data_type == 'str array') {
            strArrayAttributes.push(element.name)
          }
        }
        if (this.hideFields.includes(element.name) && !this.adminShowFields.includes(element.name)) {
          element["isHide"] = true
        } else if (!this.isAdmin && this.adminShowFields.includes(element.name)) {
          element["isHide"] = true
        } else if (this.isAdmin && this.adminShowFields.includes(element.name)) {
          element["isHide"] = false
        } else {
          element["isHide"] = false
        }        
      }
      
      this.properties = {}
      this.values = Object.assign({}, this.category.meta_data_definition.properties);
      this.propertyKeys.forEach(key => {
        if (this.values[String(key)]) {
          this.properties[String(key)] = this.values[String(key)]
        } else {
          this.properties[String(key)] = undefined
        }
        if (this.values[String(key)] == true) {
          this.values[String(key)] = "true";
        }
        if (this.values[String(key)] == false) {
          this.values[String(key)] = "false";
        }
        if (key.includes("Date")) {
          if (this.values[String(key)] != '' && this.values[String(key)] != null) {
            const d = new Date(this.values[String(key)]);
            const editField = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
            let dateString = this.datePipe.transform(editField, 'yyyy-MM-dd');        
            this.values[String(key)] = dateString;
          }
        }      
      });
      if (strArrayAttributes.length > 0) {
        this.createValuesForm(strArrayAttributes)
      }
    })
  }

  fetchProperties() {

  }

  updateCategory() {
    this.isUpdatedCategory = true;
    this.hideDocView.emit(true);
    this.catID.emit(this.categoryID)
    this.catName.emit(this.fetchedCategoryName)
  }

  back() {
    this.isUpdateCategory.emit(false);
    this.categoryService.getAll().pipe(first()).subscribe(categories => {
      this.categories = categories['results'];
    });

    this.documentSvc.getDocumentDetails(this.documentID).subscribe(details => {
        this.documentDetails = details;
        this.categoryID = details.categoryId;
        this.documentProp = this.documentDetails.metadata.properties;
        this.propertyCols = Object.keys(this.documentDetails.metadata.properties);
        this.categoryService.get(this.categoryID).subscribe(category => {
          this.categoryDetails = category;
          this.categoryName = this.categoryDetails.name;
        });
      }
    );
  }

  onSelectionChange (event: MatSelectChange) {
    let fieldName: string = String(event.source.ngControl.name);
    if (COMMENT_APPLICABLE_METADATA_KEYS.includes(fieldName)) {
      this.openDialog(fieldName)
    } else if (fieldName === MARK_FOR_DELETE_KEY) {
        this.openDeleteDialog()
      }
  }

  openDialog(fieldName: any): void {
    let dialogRef = this.dialog.open(PopUpComponent, {
      disableClose: true,
      width: '500px',
      data: { comment: this.comment, message: 'Please enter a comment for this change (no more than ' + MAX_CHARS + ' characters:' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.comment = result.comment.trim()
        let key = fieldName + COMMENT_APPENDER;
        let documentPortalUserInfo = this.documentDetails.metadata.properties["Portal User Info"];

        console.log(documentPortalUserInfo)
        if (this.portalUserInfo && Object.keys(this.portalUserInfo).length === 0)
          this.portalUserInfo = JSON.parse(JSON.stringify(documentPortalUserInfo));

        console.log(this.portalUserInfo)

        if (this.comment.trim() != '') {
          if (this.portalUserInfo[key] && Object.keys(documentPortalUserInfo).length > 0) {
            let num = documentPortalUserInfo[key]?.length;
            let versions = Number.isNaN(num) || num === undefined ? 0: num;
            console.log(this.portalUserInfo[key].length + ' ' + versions)
            if (this.portalUserInfo[key].length > versions)
              this.portalUserInfo[key][versions] = {comment: this.comment, version: (versions + 1)}
            else {
              this.portalUserInfo[key].push({
                comment: this.comment,
                version: ++versions
              });
            }
          } else {
            this.portalUserInfo[key] = []
            this.portalUserInfo[key].push({
              comment: this.comment,
              version: 1
            });
          }
          console.log(this.portalUserInfo)
        }
      }
    });
  }

  openDeleteDialog(): void {
    let dialogRef = this.dialog.open(PopUpComponent, {
      disableClose: true,
      width: '500px',
      data: { comment: this.comment, message: REASON_FOR_DELETE_PROMPT }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteComment = result.comment.trim()
      }
    });
  }
}
